var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	init: function() {
	}
};

site.tube = {
	init: function() {
		$('.tube__filter > a').on('click', function(e) {
			e.preventDefault();

			$('.tube__filter > a').each(function() {
				$(this).removeClass('selected');
			});
			$(this).addClass('selected');

			var $filterClass = $(this).attr('data-tube');
			if ($filterClass === 'all') {
				$('.video__thumb').show();
			} else {
				$('.video__thumb').each(function() {
					if ($(this).attr('data-tube') === $filterClass) {
						$(this).show();
					} else {
						$(this).hide();
					}
				});
			}
		});
	}
};

site.localExtras = {
	init: function() {
		var $body = $('body');
		if ($body.is('.speciesCategory')) {
			site.localExtras.toggleSpeciesDesc();
		}

		if ($body.is('.employeeItemView')) {
			site.localExtras.toggleEmployeeBelow();
		}
	},

	toggleSpeciesDesc: function() {
		var $extras = $('#extras');
		var $moreBtn = $extras.find('.showFullDesc');
		var $desc2 = $extras.find('.description2');

		$moreBtn.on('click', function(e) {
			$(this).toggleClass('down');
			$desc2.toggleClass('expand');
			e.preventDefault();
			if ($(this).is('.down')) {
				$desc2.css('max-height', $desc2[0].scrollHeight);
			} else {
				$desc2.css('max-height', 0);
			}
		});
	},

	toggleCategoryFormFieldVisibility: function() {
		var $layoutSelect = $('#layout');
		var $layoutSelectValue = $layoutSelect.val();
		var $latinNameElm = $('#elm_latinName');
		var $description2Elm = $('#elm_description2');

		if ($layoutSelectValue === 'species') {
			$latinNameElm.show();
			$description2Elm.show();
		} else {
			$latinNameElm.hide();
			$description2Elm.hide();
		}

		$layoutSelect.unbind().on('change', function() {
			site.localExtras.toggleCategoryFormFieldVisibility();
		});
	},
	
	toggleEmployeeBelow: function() {
		var $extras = $('#extras');
		var $togglers = $extras.find('.employee__below__toggler');
		var $fields = $extras.find('.employee__below__fields');
		$togglers.click(function() {
			$togglers.removeClass('selected');
			$(this).addClass('selected');
			$fields.find('.employee__below__field').addClass('hide');
			var $href = $(this).attr('href').replace('#', '');
			$fields.find('.' + $href).removeClass('hide');
		});

	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.mMenu.init();
	site.megamenu.init();
	site.accessibility.init();
	site.tube.init();
	site.localExtras.init();
	site.contentImage.figcaption();
	site.contentImage.fancyGallery();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}


	site.owl.init('#extras .carousel__images', {
		items: 1,
		nav: true,
		navText: ['', ''],
		autoHeight: true,
		dots: false
	});

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
